import React from 'react';
import { useSearchFiles } from '../contexts/SearchFilesContext';

function Footer() {
  const { searchCount } = useSearchFiles();
  console.log('Footer.js: Rendering with fixed position styles');

  const footerStyle = {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    backgroundColor: '#f8f9fa', // A light, modern white
    borderTop: '1px solid #dee2e6',
    padding: '05px 0',
    zIndex: 1000,
  };

  const containerStyle = {
    position: 'relative',
    width: '100%',
    padding: '0 40px',
    minHeight: '38px',
    display: 'flex',
    alignItems: 'center',
  };

  const countStyle = {
    position: 'absolute',
    left: 0,
    color: '#4A3B31',
    fontSize: '0.95em',
  };

  const pStyle = {
    margin: '0 auto',
    textAlign: 'center',
  };

  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        <span style={countStyle}>Search Count: {searchCount}</span>
        <p style={pStyle}>&copy; 2025, ChbabFinder</p>
      </div>
    </footer>
  );
}

export default Footer;
